/** Master metadata label for the hi-res inspection footer. */

import { formatBytes } from '../../../ui/bytesFormat'

export type CanvasHiResMasterMeta = {
  width?: number | null
  height?: number | null
  sizeBytes?: number | null
  createdAt?: string | null
  /** generated → "生成"; uploaded → "上传"; unknown → bare timestamp */
  origin?: 'generated' | 'uploaded' | 'unknown'
}

function formatLocalStamp(iso: string): string | null {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  const pad = (n: number) => String(n).padStart(2, '0')
  // Browser/local timezone — never print raw UTC Z string.
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function buildMasterMetaParts(
  meta: CanvasHiResMasterMeta | null | undefined,
  opts: {
    locale?: string
    generatedLabel: string
    uploadedLabel: string
  },
): string[] {
  if (!meta) return []
  const parts: string[] = []
  const w = meta.width && meta.width > 0 ? meta.width : null
  const h = meta.height && meta.height > 0 ? meta.height : null
  if (w && h) parts.push(`${w} × ${h} px`)

  if (meta.sizeBytes != null && Number.isFinite(meta.sizeBytes) && meta.sizeBytes >= 0) {
    const formatted = formatBytes(meta.sizeBytes)
    if (formatted && formatted !== '—') parts.push(formatted)
  }

  if (meta.createdAt) {
    const time = formatLocalStamp(meta.createdAt)
    if (time) {
      if (meta.origin === 'generated') parts.push(`${time} ${opts.generatedLabel}`)
      else if (meta.origin === 'uploaded') parts.push(`${time} ${opts.uploadedLabel}`)
      else parts.push(time)
    }
  }
  void opts.locale
  return parts
}

export function formatMasterMetaLabel(
  meta: CanvasHiResMasterMeta | null | undefined,
  opts: {
    locale?: string
    generatedLabel: string
    uploadedLabel: string
  },
): string | null {
  const parts = buildMasterMetaParts(meta, opts)
  return parts.length ? parts.join(' · ') : null
}
